import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {Header, Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';
import {TableSkeleton} from '@/components/Table/TableSkeleton';

import RewardsTable from './RewardsTable';
import UpdateButton from './UpdateButton';
import useReward from './useReward';

const RewardsList = () => {
  const {isLoading, isSearch, fetchList, total, list} = useReward();
  const totalFigure = total ? ` (${total.toLocaleString()})` : '';

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={'Manage Reward List' + totalFigure} />

      <PermissionsProvider permission={AfriexAdminPermission.RewardManage}>
        <div className="w-full flex justify-end mt-3">
          <UpdateButton />
        </div>
      </PermissionsProvider>

      <section className="pt-5 md:pt-5">
        {isLoading ? <TableSkeleton /> : <RewardsTable items={list} />}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={total}
          isSearch={isSearch}
        />
      ) : null}
    </main>
  );
};

export default RewardsList;
